/**
 * "SMS recovery" cross-link section shared by the check slideouts (medical,
 * VSP, EyeMed). Renders when the displayed stored check is in the SMS
 * recovery loop (link enabled — jumps to the case's conversation on the
 * Recovery Loop page) or is SMS-eligible but not yet claimed by the outreach
 * sweep (link disabled); renders nothing otherwise.
 */
interface SmsRecoverySectionProps {
  /** True when the displayed stored check is in the SMS recovery loop. */
  inRecoveryLoop?: boolean
  /** True when the stored check is SMS-eligible (recoveryAction
   *  patient_correction) — shows the section even before the outreach sweep
   *  claims the check (link disabled until it does). */
  smsRecoveryEligible?: boolean
  /** Jump to this check's Recovery Loop case (the SMS conversation). */
  onView?: () => void
}

export default function SmsRecoverySection({
  inRecoveryLoop,
  smsRecoveryEligible,
  onView,
}: SmsRecoverySectionProps) {
  if (!(inRecoveryLoop || smsRecoveryEligible) || !onView) return null
  return (
    <div className="slideout-sms-recovery">
      <div className="slideout-sms-recovery__title">SMS recovery</div>
      <p className="slideout-sms-recovery__text">
        {inRecoveryLoop
          ? 'The patient was texted for updated insurance details.'
          : 'Not in the SMS recovery loop yet — the automated outreach hasn’t picked up this check.'}
      </p>
      <button
        type="button"
        className="failure-slideout__recovery-link"
        onClick={onView}
        disabled={!inRecoveryLoop}
      >
        View SMS conversation →
      </button>
    </div>
  )
}
